import React, { Component  } from 'react';
import { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import { Home } from './Home';
import { Business } from './Business';
import { Accessibility } from './Accessibility';
import { Permitforuseexceeds } from './Permitforuseexceeds';
import About from './About';
import Contact from './Contact';
import { Websiteterms } from './Websiteterms';
import { customers } from './customers';
import { Layout } from './components/Layout';
import { NavigationBar } from './components/NavigationBar';
import Navigationdowen from './components/Navigationdowen';
import Screen from './components/Screen';
import HamburgerMenu from './components/Nav/HamburgerMenu';
import { Helmet } from "react-helmet";
import { AccessibilityWidget } from 'react-accessibility';
import  WhatsAppBot  from './WhatsAppBot';
import CookieConsent from './CookieConsent';
import Adsense from "./Adsense";
import styled from "styled-components";








const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  max-height: 90px;
  min-height: 90px;
  overflow: hidden;

  transition: all 0.3s ease;
`;



class App extends Component {


  state = {
    loaded: false
  };

  setLoaded = () => {
    this.setState({ loaded: true });
  };






 seo = {
title: "רישוי עסקים ישראל | שני אדרעי - מומחית לרישוי עסקים",
  description:
    "שני אדרעי מעניקה ליווי מקצועי בתחום רישוי עסקים, הכנת בקשות לרישיון עסק, טיפול מול הרשויות, מחלקות הנדסה ומשרדי ממשלה בכל רחבי הארץ.",
  keywords:
    "רישוי עסקים, רישיון עסק, הוצאת רישיון עסק, שני אדרעי, יועצת רישוי עסקים, רישוי עסקים בישראל, רישיון עסק לעסק, פתיחת עסק",
  url: "https://rishuy-asakim.co.il/",
  image: "/logo192.png"
};






  render() {
    return (

      <React.Fragment>
        <Router>
          <Helmet>
  <title>{this.seo.title}</title>

  <meta name="description" content={this.seo.description} />
  <meta name="keywords" content={this.seo.keywords} />

  {/* SEO חשוב */}
  <link rel="canonical" href={this.seo.url} />

  {/* Open Graph */}
  <meta property="og:title" content={this.seo.title} />
  <meta property="og:description" content={this.seo.description} />
  <meta property="og:image" content={this.seo.image} />
  <meta property="og:url" content={this.seo.url} />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="רישוי עסקים ישראל" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={this.seo.title} />
  <meta name="twitter:description" content={this.seo.description} />
  <meta name="twitter:image" content={this.seo.image} />
  <meta name="twitter:site" content="@rishuy-asakim" />
</Helmet>
  
        < NavigationBar /> 
        <HamburgerMenu/>

          <Screen />
      
          <Switch>
            <Route exact path="/" component={Home} />
             <Route path="/Business" component={Business} />
            <Route path="/Accessibility" component={Accessibility} />
            <Route path="/Permitforuseexceeds" component={Permitforuseexceeds} />
            <Route path="/about" component={About} />
            <Route path="/contact " component={Contact} />
            <Route path="/customers " component={customers} />
            <Route path="/articles" component={Websiteterms} />
          </Switch>

         
         <AccessibilityWidget />
          <WhatsAppBot />
          <CookieConsent />

        </Router>



        <Navigationdowen >

<AdsWrapper style={{ opacity: this.state.loaded ? 1 : 0 }}>
  <Adsense onLoad={this.setLoaded} />
</AdsWrapper>

        </Navigationdowen>
      </React.Fragment>
      
         

    );
  }
}

export default App;






